var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTournamentsArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5702_140)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5702_140",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0.5 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5702_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3 12L15.2 8.09995C15.3833 7.91662 15.475 7.68328 15.475 7.39995C15.475 7.11662 15.3833 6.88328 15.2 6.69995C15.0167 6.51662 14.7833 6.42495 14.5 6.42495C14.2167 6.42495 13.9833 6.51662 13.8 6.69995L9.19999 11.3C9.09999 11.4 9.02915 11.5083 8.98749 11.625C8.94582 11.7416 8.92499 11.8666 8.92499 12C8.92499 12.1333 8.94582 12.2583 8.98749 12.375C9.02915 12.4916 9.09999 12.6 9.19999 12.7L13.8 17.3C13.9833 17.4833 14.2167 17.575 14.5 17.575C14.7833 17.575 15.0167 17.4833 15.2 17.3C15.3833 17.1166 15.475 16.8833 15.475 16.6C15.475 16.3166 15.3833 16.0833 15.2 15.9L11.3 12Z",
    fill: "#FAF9F8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5702_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0.5 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournamentsArrowLeft);
export default __webpack_public_path__ + "static/media/tournaments-arrow-left.fc075736f212ade698b4ddd87046bacd.svg";
export { ForwardRef as ReactComponent };